import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c290737e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SectorListItem__container" }
const _hoisted_2 = { class: "SectorListItem__information" }
const _hoisted_3 = { class: "information__name" }
const _hoisted_4 = { class: "SectorListItem__actions" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-red-500" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "SectorListItem__courier" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["SectorListItem", { 'SectorListItem--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "information__color",
          style: _normalizeStyle(`background-color: ${_ctx.item.color}`)
        }, null, 4),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.item.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "actions__button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onView && _ctx.onView(...args)))
        }, _hoisted_6),
        (_ctx.isCanDelete)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "actions__button ml-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
            }, _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.isCanUpdate)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "actions__button ml-2",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args)))
            }, _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_new_select, {
        placeholder: "Курьер",
        "search-without-refresh": "",
        label: "fullName",
        searchBy: "fullName",
        "can-deselect": false,
        disabled: _ctx.isCouriersLoading || _ctx.isCourierAttaching || _ctx.isCourierDetaching || !_ctx.isCanAttachCourier,
        loading: _ctx.isCouriersLoading,
        failed: _ctx.isCouriersFailed,
        options: _ctx.couriers,
        value: _ctx.selectedCourier,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCourier) = $event)),
        onRefresh: _ctx.onReloadCouriers,
        onChange: _ctx.onAttachCourier
      }, null, 8, ["disabled", "loading", "failed", "options", "value", "onRefresh", "onChange"]),
      _createVNode(_component_new_button, {
        type: "button",
        class: _normalizeClass(["actions__button", {
                    'NewButton--red': _ctx.isCanDetachCourier,
                    'NewButton--secondary': !_ctx.isCanDetachCourier
                }]),
        loading: _ctx.isCourierDetaching,
        disabled: !_ctx.isCanDetachCourier || _ctx.isCourierDetaching,
        onClick: _ctx.onDetachCourier
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }, 8, ["class", "loading", "disabled", "onClick"])
    ])
  ], 2))
}